import { z } from "zod";
import type { CategoryPlugin } from "../plugin";

const schema = z.object({
  sticks_count: z.number().int().positive().optional(),
  burn_minutes: z.number().int().positive().optional(),
  format: z.enum(["Incense","Bakhoor","Cone"]).optional(),
});

export const plugin: CategoryPlugin<z.infer<typeof schema>> = {
  metadata: {
    id: "scented-sticks", slug: "scented-sticks", name: "Scented Sticks",
    tagline: "Slow-burn incense and bakhoor", status: "launched",
  },
  attributeSchema: schema,
  search: { columns: ["name","family","notes"], attributes: ["format"] },
  facets: [
    { key: "format", label: "Format", type: "enum", source: "attribute",
      options: ["Incense","Bakhoor","Cone"] },
    { key: "family", label: "Family", type: "enum", source: "column",
      options: ["Oriental","Woody","Amber","Floral"] },
    { key: "burn_minutes", label: "Burn (min)", type: "range", source: "attribute",
      min: 5, max: 120, step: 5, unit: "min" },
    { key: "price", label: "Price (₹)", type: "range", source: "column",
      min: 10, max: 200, step: 5, unit: "₹" },
  ],
  pdpPanels: [
    { key: "product", label: "Product details", attributes: ["format","sticks_count","burn_minutes"] },
  ],
  seo: {
    titleTemplate: "{name} · CB16 Incense",
    descriptionTemplate: "{name} — slow-burn scented sticks.",
    routePrefix: "scented-sticks",
  },
  adminForm: [
    { key: "sticks_count", label: "Sticks per pack", kind: "number" },
    { key: "burn_minutes", label: "Burn (min)", kind: "number" },
    { key: "format", label: "Format", kind: "select", options: ["Incense","Bakhoor","Cone"] },
  ],
};
